module.exports = __webpack_public_path__ + "static/workplace-lessons-from-the-pandemic-4afe1a0494ea4a8c0b572d8107f4392a.jpg";